import { render, staticRenderFns } from "./editItemReleaseViewList.vue?vue&type=template&id=bee26b5c&scoped=true"
import script from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
export * from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
import style0 from "./editItemReleaseViewList.vue?vue&type=style&index=0&id=bee26b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee26b5c",
  null
  
)

export default component.exports